import { Component, OnInit, computed, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PericiasService } from '../../core/services/pericias.service';
import { Pericia, ProgramaTrabalho } from '../../core/models/pericia.model';

@Component({
  selector: 'app-pendencias',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './pendencias.component.html',
  styleUrl: './pendencias.component.scss'
})
export class PendenciasComponent implements OnInit {
  pericias = signal<Pericia[]>([]);
  tarefas = signal<ProgramaTrabalho[]>([]);
  statusFiltro = '';
  responsavelFiltro = '';
  textoFiltro = '';

  statusOpcoes = ['Pendente', 'Em andamento', 'Aguardando documento', 'Atrasada'];

  constructor(private readonly service: PericiasService) {}

  ngOnInit(): void {
    this.carregar();
  }

  carregar(): void {
    this.service.listar().subscribe(dados => this.pericias.set(dados));
    this.service.listarProgramasTrabalho().subscribe(dados => this.tarefas.set(dados));
  }

  pendencias = computed(() => {
    const termo = this.textoFiltro.toLowerCase().trim();
    return this.tarefas().filter(t => {
      const statusAberto = !['Concluída', 'Cancelada'].includes(t.status);
      const bateStatus = !this.statusFiltro || t.status === this.statusFiltro;
      const bateResp = !this.responsavelFiltro || (t.responsavel || '').toLowerCase().includes(this.responsavelFiltro.toLowerCase());
      const p = this.nomePericia(t.pericia_id).toLowerCase();
      const texto = [t.etapa, t.tarefa, t.responsavel, t.observacoes, p, t.status].join(' ').toLowerCase();
      const bateTexto = !termo || texto.includes(termo);
      return statusAberto && bateStatus && bateResp && bateTexto;
    });
  });

  nomePericia(id: number): string {
    const p = this.pericias().find(x => x.id === id);
    return p ? `${p.codigo} - ${p.titulo}` : `Perícia ${id}`;
  }

  classeStatus(status: string): string {
    return 'status-' + (status || 'padrao').toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-');
  }
}
